import React, { Fragment, useEffect, useState } from "react";
import { styled, withStyle } from "baseui";
import { Tabs, Tab, FILL  } from "baseui/tabs-motion";
import TemplateFolderTreeSidebar from "./TemplateFolderTreeSidebar";
import TemplateParameterTreeSidebar from "./TemplateParameterTreeSidebar";
import TemplateParameterDetailView from "./TemplateParameterDetailView";
import TemplateFileContentView from "./TemplateFileContentView";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ROUTES_PATH from "../../constants/RouteConstants";
import TemplateEditorAsideView from "./TemplateEditorAsideView";
import TemplateSubHeaderView from "./TemplateSubHeaderView";
import * as AppConstants from "../../constants/AppConstants";
import { FaTasks, FaFolderOpen } from "react-icons/fa";
import { connect } from "react-redux";
import { fetchTemplateById } from "../../redux/template/TemplateThunk";
import { Route } from "react-router-dom";
import useToaster from "../../hooks/useToaster";
import FetchErrorComponent from "../../components/fetch-error/FetchErrorComponent";
import SubHeader from "../../components/sub-header/SubHeader";
import {Spinner, SIZE} from "baseui/spinner";
import { Grid, Cell, STYLE } from 'baseui/layout-grid';

const ViewContainer = styled(Grid, ({ $theme }) => ({
  margin: "auto auto",
  padding: AppConstants.APP_MAIN_PADDING,
}));
const DetailsArea = styled(Cell, ({ $theme }) => ({    
  height: AppConstants.APP_GLOBAL_HEIGHT,
}));

const SidebarArea = styled(Cell, ({ $theme }) => ({
  padding: "0px 10px 0px 0px",
  borderRight: `${$theme.colors.primary}  solid`,
}));

const FolderArea = styled("div", ({ $theme }) => ({
  width: "100%",
}));
const OutlineArea = styled("div", ({ $theme }) => ({
  width: "100%",
}));
const PropertiesAsideArea = styled(Cell, ({ $theme }) => ({
  padding: "0px 10px",
  // height: AppConstants.APP_GLOBAL_HEIGHT,
  // overflowY: "hidden",
}));
const MessageContainer = styled("div", ({ $theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));
const ExtraLargeSpinner = withStyle(Spinner, {
  width: '100px',
  height: '100px',
  borderLeftWidth: '12px',
  borderRightWidth: '12px',
  borderTopWidth: '12px',
  borderBottomWidth: '12px',
});
function TemplateEditorView(props) {
  const history = useHistory();
  const [childKey, setitemschildKey] = useState(7);
  const [activeKey, setActiveKey] = React.useState("0");
  const [templateImageFile, setTemplateImageFile] = useState(null);
  const [modelerImageFile, setModelerImageFile] = useState(null);
  const location = useLocation();
  const { templateId } = useParams();
  useToaster(props.errorMessage)

  
  //Force update
  const handleItemsChanged = (newItems) => {
    setitemschildKey(childKey * 89);
  };
  useEffect(() => {
    setitemschildKey(childKey * 89);
  }, [props.templateUpdated]);

  const OUTLINE_TABS_ROUTES = [
    ROUTES_PATH.templateParameter,
    ROUTES_PATH.templateFolder,
  ];
  
  useEffect(() => {
    props.fetchActvieTemplate(templateId);    
    setActiveKey(OUTLINE_TABS_ROUTES.indexOf((location.pathname.split('/') || []).pop()).toString());
  }, []);

  useEffect(() => {
    if (props.deleted) {
      history.push({
        pathname: `${ROUTES_PATH.templates}managed`,
        search: 'page=1&time=all'
      })
    }
  }, [props.activeTemplate, props.deleted]);
  
  if (props.isLoading) {
    return (
      <>
        <SubHeader></SubHeader>
        <MessageContainer>
          {/* You can replace the following line with your own LoadingComponent */}
          <ExtraLargeSpinner></ExtraLargeSpinner>
        </MessageContainer>
      </>
    );
  }

  if (props.fetchError) {
    return (
      <>
        <SubHeader></SubHeader>
        <MessageContainer>
          <FetchErrorComponent onRefresh={()=>props.fetchActvieTemplate(templateId)} message={props.fetchErrorMessage} />
        </MessageContainer>
      </>
    );
  }
  return (
    <Fragment>
      <TemplateSubHeaderView/>
      <ViewContainer>
        <SidebarArea  span={[1, 2, 3]}>

          <Tabs
            fill={FILL.fixed}
            onChange={({ activeKey }) => {
              setActiveKey(activeKey);
              history.push(OUTLINE_TABS_ROUTES[activeKey]);
            }}
            activeKey={activeKey}
          >
            <Tab title="Parameters" artwork={FaTasks}>
              <OutlineArea>
                <TemplateParameterTreeSidebar
                  key={childKey}
                  onItemsChanged={() => handleItemsChanged()}
                />
              </OutlineArea>
            </Tab>
            <Tab title="Folders" artwork={FaFolderOpen}>
              <FolderArea>
                <TemplateFolderTreeSidebar templateId={templateId} />
              </FolderArea>
            </Tab>
          </Tabs>
        </SidebarArea>
        <DetailsArea span={[2, 4, 6]}>
          <Route
            exact
            path={`${ROUTES_PATH.templateEditor}:templateId/${ROUTES_PATH.templateParameter}`}
            component={() => (
              <TemplateParameterDetailView
                onItemsChanged={() => handleItemsChanged()}
              />
            )}
          />
          <Route
            exact
            path={`${ROUTES_PATH.templateEditor}:templateId/${ROUTES_PATH.templateFolder}`}
            component={() => (
              <TemplateFileContentView/>
            )}
          />
        </DetailsArea>
        <PropertiesAsideArea span={[1, 2, 3]}>
          <TemplateEditorAsideView
            handleTemplateFileUpload={(acceptedFiles) =>
              setTemplateImageFile(acceptedFiles)
            }
            handleModelerFileUpload={(acceptedFiles) =>
              setModelerImageFile(acceptedFiles)
            }
          />
        </PropertiesAsideArea>
      </ViewContainer>
    </Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    activeTemplate: state.template.activeTemplate,
    templateUpdated: state.template.activeTemplate?.updated,
    fetchError: state.template.activeTemplate?.fetchError,
    fetchErrorMessage: state.template.activeTemplate?.fetchErrorMessage,
    error: state.template.activeTemplate?.error,
    errorMessage: state.template.activeTemplate?.errorMessage,
    deleted: state.template?.deleted,
    isLoading: state.template.activeTemplate?.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActvieTemplate: (templatedId) => {
      dispatch(fetchTemplateById(templatedId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateEditorView);
